// removed by extract-text-webpack-plugin
module.exports = {"container":"container-2uT_A","nav":"nav-1mUV1","shortcuts":"shortcuts-3__Mj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/header/_header.css
// module id = 1232
// module chunks = 1